export default __webpack_public_path__ + "static/media/desktopangels1.5a39f7fe.jpg";